import { strokeStyle } from "./stroke";

// Mock `ICON.chart` (prototype.html): the entry window and SCR-03 card icon.
function ChartIcon({ color = "var(--accent-solid)" }) {
  return (
    <svg
      aria-hidden="true"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={strokeStyle(color)}
    >
      <path d="M4 19V5M4 19h16" />
      <path d="M8 15l4-5 3 3 5-6" />
    </svg>
  );
}

export default ChartIcon;
